module.exports = __webpack_public_path__ + "img-dashboard/register/check-circle-white.0dceaa6f.png";